import { getSortAndFilterQueryString } from "../view/urlService";
import { MAIL_ACCOUNT_API, MAIL_RECIPIENT_API } from "../vars";
import store from "../app/store";
import { createAction } from "@reduxjs/toolkit";
import { securedFetch, secureField } from "../auth/authService";
import { ACTION_MAIL_RECIPIENTS_LOADED } from "./AlertNotificationPageReducer";
import { showSuccessToast, showWarningToast } from "../validation/ToastContainer";
import { deepCopy } from "../utils";
import {getAuthHeader} from "../auth/authService";

export async function getPaginated(pageNumber, pageSize) {

    const queryString = getSortAndFilterQueryString(pageNumber, pageSize);

    return securedFetch(`${MAIL_RECIPIENT_API}/page?${queryString}`).then(response => response.json()).then(data => {
        store.dispatch(createAction(ACTION_MAIL_RECIPIENTS_LOADED)({ recipients: data.page }));
        return { recipients: data.page, totalPages: data.total, totalRecords: data.records }
    });

}

export async function getMailAccountData() {
    return securedFetch(MAIL_ACCOUNT_API).then(response => response.json());
}

export async function saveMailAccountData(account, passwordChanged) {
    const mailData = deepCopy(account);
    if (passwordChanged) {
        return secureField('password', mailData)
            .then((mailDataWithSecuredField) =>
                securedFetch(MAIL_ACCOUNT_API, mailDataWithSecuredField, 'POST'))
    } else {
        return securedFetch(MAIL_ACCOUNT_API, mailData, 'POST');
    }
}

export function uploadMailAccountCertificate(file) {
    const formData = new FormData();
    formData.append('certificate', file);
    //formData.append('filename', 'reportlogo');

    
    return fetch(`${MAIL_ACCOUNT_API}/upload-certificate`,
        {
            method: 'POST',
            headers: {
                ...getAuthHeader()
            },
            body: formData
        }).then(response => response);
}

export async function update(recipient) {
    return securedFetch(`${MAIL_RECIPIENT_API}/${recipient.id}`, recipient, 'POST');
}

export async function save(recipient) {
    const response = await securedFetch(MAIL_RECIPIENT_API, recipient, 'POST');
    if (!response.ok) {
        showWarningToast("Recipient with such email already exist", "Add Recipient", "aborted");
    } else {
        showSuccessToast("Recipient was saved", "Add Recipient")
    }
    return response.ok;
}

export async function deleteRecipients(recipientIdList) {
    for (const id of recipientIdList) {
        await securedFetch(`${MAIL_RECIPIENT_API}/${id}`, null, 'DELETE').then(response => response.ok);
    }
}
